import ReportsSubscribe from './reports-subscribe';

export default ReportsSubscribe;
